import { isNotDefined } from '@sgme/fp';
import { missedDealFeedbackConnector } from 'apiConnector/missed-deal-feedback';
import * as apiErrorHelper from 'epic/apiErrorEpicHelper';
import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import {
  missedDealFeedbackReferentialReceived,
  missedDealFeedbackReferentialRequestFailed,
} from 'state/missed-deal-feeedback/actions';
import { getFeedbackPricerId } from 'state/missed-deal-feeedback/selectors';
import type { EpicWithThunk } from 'state/state.common';

export function fetchCompetitionParameters(): EpicWithThunk {
  return (actions$, state$, { oldHttpClient }) => {
    return actions$.pipe(
      ofType('MISSED_DEAL_FEEDBACK_REQUESTED'),
      withLatestFrom(state$),
      mergeMap(([{ tabId }, state]) => {
        const pricerId = getFeedbackPricerId(state, tabId);
        if (isNotDefined(pricerId)) {
          return EMPTY;
        }
        return missedDealFeedbackConnector(oldHttpClient)
          .fetchAllCompetitionParameters(pricerId)
          .pipe(
            map(data => missedDealFeedbackReferentialReceived(tabId, data)),
            catchError(error =>
              of(
                missedDealFeedbackReferentialRequestFailed(
                  tabId,
                  apiErrorHelper.toApiErrorMessage(error, { handleHttpTimeout: true }),
                  error,
                ),
              ),
            ),
          );
      }),
    );
  };
}
